module.exports = __webpack_public_path__ + "16a857a992524ef9b735d38329f13387.png";